import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import { getAction, httpAction } from '@api/manage';
import IwsUpload from '@comp/upload/IwsUpload';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import { getBindingValue, getLargePermission } from '@/utils/hasPermission';
export default {
  name: 'CarGasolineModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      loginUser: '',
      carDisableStatus: false,
      userTree: [],
      carList: [],
      superAdminStatus: false,
      title: '车辆加油记录表单',
      tableName: 'ea_asset_car_gasoline',
      form_fields: ['carId', 'userId', 'apparentKilometer', 'refuelingVolume', 'refuelingAmount', 'cardBalance', 'tenantId', 'remark'],
      form_fields_time: ['gasolineDate'],
      validatorRules: {
        carId: {
          rules: [{
            required: true,
            message: '请选择车辆!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择加油人员!'
          }]
        },
        gasolineDate: {
          rules: [{
            required: true,
            message: '请选择加油日期!'
          }]
        },
        apparentKilometer: {
          rules: [{
            required: true,
            message: '请输入表显公里数!'
          }]
        },
        cardBalance: {
          rules: [{
            required: true,
            message: '请输入加油金额!'
          }]
        },
        refuelingAmount: {
          rules: [{
            required: true,
            message: '请输入油卡余额!'
          }]
        },
        refuelingVolume: {
          rules: [{
            required: true,
            message: '请输入加油量!'
          }]
        }
      },
      url: {
        carList: '/ea/asset/car/queryCarCards'
      }
    };
  },
  props: {
    pagePath: String,
    carDetails: Boolean,
    carId: {
      type: Number,
      default: null
    },
    permissionObj: {
      type: Object,
      default: function _default() {
        edit: '';
      }
    }
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
    this.queryUserTreeList();
    this.queryCarList();
  },
  methods: {
    moment: moment,
    add: function add() {
      this.carDisableStatus = false;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);

      if (this.carDetails) {
        this.carDisableStatus = true;
        this.model.carId = parseInt(this.carId);
      }

      this.visible = true;

      if (!this.model.userId) {
        this.model.userId = this.loginUser;
        if (this.model.userId != 1) this.superAdminStatus = true;
        this.model.gasolineDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    queryCarList: function queryCarList() {
      var that = this;
      that.carList = [];
      getAction(that.url.carList).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this2 = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        // let addTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        // let buTime = values.sdate._i
        // let ATime = new Date(addTime).getTime()
        // // let CTime = new Date(buTime).getTime()
        // if (!err || ATime - CTime < 60 * 60 * 1000) {
        that.confirmLoading = true;
        var formData = Object.assign(that.model, values); //时间格式化
        // that.form_fields_time.forEach(function (item, index) {
        //   formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null
        // })

        formData.gasolineDate = formData.gasolineDate ? formData.gasolineDate.format('YYYY-MM-DD HH:mm:ss') : null;
        formData = _this3.$refs.iwupload.getUploadListToFromData(formData); //debugger
        //console.log(formData)

        var httpurl = '',
            method = '';
        var headers = {
          tableName: _this3.permissionObj.edit.split(':')[1]
        };

        if (!_this3.model.id) {
          httpurl = _this3.url.add ? _this3.url.add : _this3.pagePath;
          method = 'post';
        } else {
          httpurl = _this3.url.edit ? _this3.url.edit : _this3.pagePath;
          method = 'put';
          console.log('headers', _this3.permissionObj.edit);

          if (_this3.permissionObj.edit) {
            headers.id = _this3.model.id; // let largePermission = getLargePermission({ value: that.permissionObj.edit })
            // getBindingValue(headers, largePermission)
          }
        }

        console.log('headers', headers);
        httpAction(httpurl, formData, method, headers).then(function (res) {
          if (res.success) {
            _this3.$refs.iwupload.resetUploadFiles();

            that.$notification.success({
              message: res.message
            });
            that.$emit('ok');
            that.close();
          } else {
            that.$notification.warning({
              message: res.message
            });
          }
        }).finally(function () {
          that.confirmLoading = false;
        });
      });
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};